import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';
import { easeTransform } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

const setArrowPosition = (position: 'up' | 'right' | 'down' | 'left'): string => {
    if (position === 'down') {
        return 'rotate(0)';
    }

    if (position === 'right') {
        return 'rotate(-90deg)';
    }

    if (position === 'up') {
        return 'rotate(180deg)';
    }

    return 'rotate(90deg)';
};

interface SvgElementPropsType {
    position: 'up' | 'right' | 'down' | 'left';
}

const SvgElement = styled('svg', { label: 'SvgElement' })<SvgElementPropsType>`
    height: auto;
    transform: ${({ position }): string => setArrowPosition(position)};
    transition: ${easeTransform};
`;

interface ArrowIconPropsType {
    className?: string;
    onClick?: () => void;
    position: 'up' | 'right' | 'down' | 'left';
}

export const ArrowIcon = observer(
    'ArrowIcon',
    ({ className, position, onClick }: ArrowIconPropsType): React.ReactElement => {
        return (
            <SvgElement
                className={className}
                fill='#fff'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                position={position}
                onClick={onClick}
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M17.5 12L12 17.5L6.5 12L7.49708 11.0351L11.3246 14.8626V6.5H12.6755V14.8626L16.5351 11.0351L17.5 12Z'
                    fill='#fill'
                />
            </SvgElement>
        );
    }
);
